/**
 * Site sensors API — fetches the FE-contract sensor readings snapshot for a
 * single site from the odl_app sensor endpoint.
 *
 * The response carries temp/humidity readings pre-converted to the requesting
 * user's measurement system, plus raw values for the live socket path.
 */
import apiClient from '@sophocles/http-common';

/**
 * Fetch the sensor readings contract for a site.
 *
 * @param {number|string} siteId
 * @returns {Promise<object>} FE-contract sensor snapshot
 */
export const fetchSiteSensorsApi = siteId =>
  apiClient.get(`/odl-app/sites/${siteId}/sensors/`).then(res => res.data.data);
